import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { RechtSearchErweitertRequestMeta } from '../../../core/gb-api';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgForm, Validator } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CapFormRowDirective } from '../../form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-stichwort-ablaufdatum',
  templateUrl: './stichwort-ablaufdatum.component.html',
  styleUrls: ['./stichwort-ablaufdatum.component.scss'],
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => StichwortAblaufdatumComponent), multi: true },
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => StichwortAblaufdatumComponent), multi: true }
  ],
  imports: [FormsModule, CapFormRowDirective, CapFormControlComponent, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class StichwortAblaufdatumComponent implements ControlValueAccessor, Validator {
  @ViewChild(NgForm, { static: false })
  form: NgForm;
  @Input() heading: string;

  model: RechtSearchErweitertRequestMeta;

  onTouched: () => void;
  onValidatorChange: () => void;

  private _subscription: Subscription;

  constructor() {}

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this._subscription = this.form.control.valueChanges.subscribe(() => {
      // we can't pass the inner form's model because that model is derived from the form model
      // which does not know about, and therefore copy, properties not mapped with ngModel, such as our metas
      // to preserve the metas, we therefore pass our original model. Hopefully this never causes a problem ... (MOO)
      fn(this.model);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(c: AbstractControl): {
    [key: string]: any;
  } | null {
    return this.form.valid ? null : { nestedErrors: true };
    // we can't return {} to signal nested errors in a semantically appropriate way
    // because mergeErrors helpfully ignores objects without keys :-(
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }
}
